import { useSelector } from 'hooks/utils';
import { useMemo } from 'react';
import { selectProjectsById, selectAllProjectsIds } from 'store/data/projects';
import { SelectItem } from 'types/index';

export function useAllProjectsNameId() {
	const allProjectsIds = useSelector(state => selectAllProjectsIds(state.data.projects));
	const projectsById = useSelector(state => selectProjectsById(state.data.projects));

	const selectItems = useMemo(() => {
		const items: SelectItem[] = [];

		const ids = allProjectsIds;

		ids.forEach(projectId => {
			const project = projectsById[projectId];

			const item: SelectItem = {
				label: project.projectName,
				value: projectId
			};

			items.push(item);
		});

		return items;
	}, [allProjectsIds, projectsById]);

	return selectItems;
}
